import { useEffect, useState, useCallback } from "react";

const SECTIONS = [
  { id: "hero", label: "Hero" },
  { id: "diagnostic", label: "Diagnostic" },
  { id: "fixable", label: "Fixable" },
  { id: "methodology", label: "Methodology" },
  { id: "evidence", label: "Evidence" },
  { id: "ownership", label: "Ownership" },
  { id: "gatekeeper", label: "Gatekeeper" },
  { id: "mandate", label: "Mandate" },
];

const SectionProgressBar = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleScroll = useCallback(() => {
    const markerY = window.scrollY + window.innerHeight * 0.35;
    let current = 0;

    for (let i = SECTIONS.length - 1; i >= 0; i--) {
      const el = document.getElementById(SECTIONS[i].id);
      if (!el) continue;

      const absoluteTop = el.getBoundingClientRect().top + window.scrollY;
      if (absoluteTop <= markerY) {
        current = i;
        break;
      }
    }

    setActiveIndex((prev) => (prev === current ? prev : current));
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
    window.addEventListener("load", handleScroll);

    requestAnimationFrame(handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
      window.removeEventListener("load", handleScroll);
    };
  }, [handleScroll]);

  const handleClick = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      aria-label="Section progress"
      className="fixed right-6 top-1/2 -translate-y-1/2 z-50 hidden lg:flex flex-col items-center gap-3"
    >
      {SECTIONS.map((section, index) => {
        const isActive = index === activeIndex;
        const isVisited = index < activeIndex;

        return (
          <button
            key={section.id}
            onClick={() => handleClick(section.id)}
            aria-label={`Scroll to ${section.label}`}
            aria-current={isActive ? "step" : undefined}
            className={`
              w-2 h-2 rounded-full transition-all duration-300 border-0 p-0
              ${isActive
                ? "bg-primary scale-150 shadow-[0_0_8px_hsl(var(--primary)/0.4)]"
                : isVisited
                  ? "bg-muted-foreground hover:bg-foreground"
                  : "bg-muted hover:bg-muted-foreground"
              }
            `}
          />
        );
      })}
    </nav>
  );
};

export default SectionProgressBar;
